<template>
  <div class="buy">
    <Row justify="center" type="flex">
      <Col span="24">
        <div class="banner-box">
          <img
            class="banner-img"
            src="../../static/img/banner/product.png"
            alt="产品banner"
          />
          <div class="banner_font">
            <div class="banner_font1">提供全面的智能施工解决方案</div>
            <div class="banner_font2">包括传感器、云计算和大数据分析等技术</div>
            <div class="banner_font3">
              让我们一起创造更加智慧、高效和可持续的建设行业
            </div>
          </div>
        </div>
      </Col>
    </Row>

    <Row justify="center" type="flex">
      <Col span="24" class="col_bread">
        <div class="tab-wrap">
          <ul class="navigation">
            <li
              @click="goPage('/home/Buy/WisdomSite')"
              :class="{ active: $route.path === '/home/Buy/WisdomSite' }"
            >
              智慧工地平台
            </li>
            <li
              @click="goPage('/home/Buy/inspection')"
              :class="{ active: $route.path === '/home/Buy/inspection' }"
            >
              AI智能巡检
            </li>
            <li
              @click="goPage('/home/Buy/SolarRobot')"
              :class="{ active: $route.path === '/home/Buy/SolarRobot' }"
            >
              智能机器人
            </li>
            <li
              @click="goPage('/home/Buy/Resiliometer')"
              :class="{ active: $route.path === '/home/Buy/Resiliometer' }"
            >
              实测实量平台
            </li>
            <li
              @click="goPage('/home/Buy/VR')"
              :class="{ active: $route.path === '/home/Buy/VR' }"
            >
              智慧展厅一体化解决方案
            </li>
            <li
              @click="goPage('/home/Buy/Quality')"
              :class="{ active: $route.path === '/home/Buy/Quality' }"
            >
              智能化安全体验区
            </li>
          </ul>
        </div>
      </Col>
    </Row>

    <div class="buy_menu01">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "Buy",
  created() {
    window.scrollTo(0, 0);
  },
  watch: {
    "$route.path"() {
      window.scrollTo(0, 0);
    },
  },
  methods: {
    goPage(path) {
      this.$router.push({ path });
    },
  },
};
</script>

<style scoped>
.buy {
  width: 100%;
  background: #ffffff;
}
/* Banner容器 */
.banner-box {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.banner-img {
  width: 100%;
  height: 500px;
  object-fit: cover;
}
.banner_font {
  position: absolute;
  top: 50%;
  left: 45%;
  transform: translateY(-50%);
}
.banner_font1 {
  font-size: 30px;
  font-family: lianmengqiyilushuaizhengruiheiti;
  color: #1966ff;
}
.banner_font2 {
  font-size: 22px;
  font-family: lianmengqiyilushuaizhengruiheiti;
  color: #1966ff;
  margin-top: 16px;
}
.banner_font3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  color: #333;
  margin-top: 24px;
}
/* 顶部产品Tab导航 */
.tab-wrap {
  background-color: #1966ff;
  min-height: 50px;
}
.navigation {
  list-style: none;
  display: flex;
  padding: 0 5%;
  margin: 0;
}
.navigation li {
  flex: 1;
  min-width: 120px;
  text-align: center;
  line-height: 50px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}
.navigation li:hover {
  background-color: #2d8cf0;
}
.navigation li.active {
  background-color: #fff;
  color: #1966ff;
  font-weight: bold;
}
/* 子页面容器 */
.buy_menu01 {
  max-width: 1230px;
  margin: 20px auto 0;
  padding: 0 20px 60px;
}

/* 移动端适配 */
@media (max-width: 992px) {
  .banner-img {
    height: 280px;
  }
  .banner_font {
    left: 8%;
  }
  .banner_font1 {
    font-size: 22px;
  }
  .banner_font2 {
    font-size: 18px;
  }
  .navigation {
    flex-wrap: wrap;
  }
  .navigation li {
    flex: none;
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Buy.vue